import { UserAreaBoundary } from "@/components/UserAreaBoundary";
import { FMSSubpage } from "@/pages/DashboardPage/fms/FMSSubpage";
import { ServiceManagerSubpage } from "@/pages/DashboardPage/sm/ServiceManagerSubpage";
import { TSSSubpage } from "@/pages/DashboardPage/tss/TSSSubpage";

const DashboardLegacyPage = () => {
    return (
        <>
            <UserAreaBoundary areas={["ServiceManager_Core"]}>
                <ServiceManagerSubpage />
            </UserAreaBoundary>
            <UserAreaBoundary areas={["TSS_Core"]}>
                <TSSSubpage />
            </UserAreaBoundary>
            <UserAreaBoundary areas={["FMS_Core"]}>
                <FMSSubpage />
            </UserAreaBoundary>
        </>
    );
};

export { DashboardLegacyPage };
